import { z } from 'zod'

import { FormError } from '@forto-dev/platform-localisation'

export const RequestResetPasswordFormSchema = z.object({
  email: z.string().email(FormError.EMAIL),
})

export type RequestResetPasswordFormSchemaType = z.infer<typeof RequestResetPasswordFormSchema>
